 export const RoleId = Object.freeze({
    Admin: 1,
    User: 2,
    SuperAdmin: 3,
    });
